import { NgHybridStateDeclaration }    from '@uirouter/angular-hybrid';

import { SessionService }               from '../sessions/session.service';
import { WorkshopWebSettingsComponent } from './workshop-web.settings.component';

export const WorkshopWebStates : Array<NgHybridStateDeclaration> = [
  {
    component: WorkshopWebSettingsComponent,
    name     : 'app.workshop-web-settings',
    url      : '/workshop-web-settings',
    resolve  : [
      {
        deps     : [ SessionService ],
        resolveFn: ( sessionService : SessionService ) => sessionService.refresh(),
        token    : 'session'
      }
    ]
  }
];
